module.exports = __webpack_public_path__ + "img/11_49.187238a4.png";